import * as React from 'react';

import config from '@xingternal/crate-stubs-hops-config';

export { importComponent } from './hops-react';

declare global {
  // eslint-disable-next-line no-var
  var _hopsServerData: Partial<ServerData> | undefined;
}

export { config };

export type LOGIN_STATE_TYPE = 'LOGGED_IN' | 'LOGGED_OUT' | 'SOFT_LOGGED_IN';

export const LOGIN_STATE = {
  LOGGED_IN: 'LOGGED_IN' as const,
  LOGGED_OUT: 'LOGGED_OUT' as const,
  SOFT_LOGGED_IN: 'SOFT_LOGGED_IN' as const,
};

export interface ServerData {
  language: string;
  loginState: LOGIN_STATE_TYPE;
  loginUrl: string;
}

export const serverDataContext = React.createContext<ServerData>({
  language: 'en',
  loginState: 'LOGGED_OUT',
  loginUrl: 'https://login.xing.com',
  ...globalThis._hopsServerData,
});
serverDataContext.displayName = 'Hops.ServerData';

export function useConfig(): Record<string, unknown> {
  return { ...config };
}

export function useLoginState(): string {
  const { loginState } = useServerData();

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return loginState as string;
}

export function useServerData(): ServerData {
  return React.useContext(serverDataContext);
}

export function withServerData(): never {
  throw new Error('Using withServerData from Hops in Crate is not supported');
}

export function withConfig(
  Component: React.ComponentType<{ config: Record<string, unknown> }>
): React.ComponentType {
  const WithConfig: React.FC = (props) => {
    return React.createElement(Component, { ...props, config });
  };
  WithConfig.displayName = 'WithConfig';
  return WithConfig;
}

export function useFetch(): typeof fetch {
  return (): never => {
    throw new Error('Using useFetch from Hops in Crate is not supported');
  };
}

export function useFetchJson(): typeof fetch {
  return (): never => {
    throw new Error('Using useFetchJson from Hops in Crate is not supported');
  };
}

export function withFetch(): never {
  throw new Error('Using withFetch from Hops in Crate is not supported');
}

export function withFetchJson(): never {
  throw new Error('Using withFetchJson from Hops in Crate is not supported');
}

export function captureException(error: Error): void {
  setTimeout(() => {
    throw error;
  }, 0);
}

export const Sentry = {};
